import { matchTrakerType } from 'utils/constants/swarm/spring-configs';
import { SpringConfigsType } from 'interfaces/generic';

type TUkConfigs = Required<
  Pick<
    SpringConfigsType,
    | 'GAMBLING_COMMISSION'
    | 'LOGIN_FREEZE'
    | 'IOVATION_ENABLED'
    | 'CASINO_TIMER_NET_WIN'
    | 'CASINO_GAME_SWITCHING_DURING_GAME_SESSION'
    | 'MATCH_TRACKER_URL'
    | 'GAMBLING_MESSAGE_URL'
    | 'GAMBLING_MESSAGE_ENABLED'
    | 'BETSLIP_TYPE'
    | 'SHOW_GAMBLING_WITH_LOGO'
    | 'SHOULD_IGNORE_USER_FROZEN_BALANCE'
    | 'CASINO_DISABLE_FUN_MODE_FOR_NOT_AUTHORIZED_USERS'
    | 'IS_BONUS_BALANCE_VIEW_EXPANDED_BY_DEFAULT'
    | 'HAS_BONUS_ELIGIBLE'
    | 'SHOW_DEPOSIT_CONFIRMATION_MESSAGE'
    | 'IS_PAYMENT_INFO_TEXT_LONGER'
    | 'IS_CASINO_FUN_MODE_UNAVAILABLE'
    | 'SHOW_MULTIPLE_BET_ORIGINAL_TOTAL_ODDS'
    | 'MIN_DEPOSIT_LIMIT'
    | 'CASINO_MULTIVIEW_ENABLED'
    | 'SHOW_ONLY_SINGLE_AND_MULTIPLE_ODDS_IN_BET_HISTORY'
    | 'OLYMPIC_ICON_OTHER'
    | 'CONFLICT_MESSAGE_IN_FOOTER'
    | 'GAMBLING_LiNKS'
    | 'NOTIFICATION_ACTIVE_TAB'
  >
>;

export default {
  GAMBLING_COMMISSION: true,
  LOGIN_FREEZE: true,
  IOVATION_ENABLED: true,
  DOC_UPLOAD_TRU_NARRATIVE: true,
  CASINO_TIMER_NET_WIN: true,
  CASINO_GAME_SWITCHING_DURING_GAME_SESSION: false,
  GAMBLING_MESSAGE_ENABLED: true,
  GAMBLING_MESSAGE_URL: 'http://www.begambleaware.org',
  MATCH_TRACKER_URL: matchTrakerType[1],
  BETSLIP_TYPE: 1,
  SHOW_GAMBLING_WITH_LOGO: true,
  SHOULD_IGNORE_USER_FROZEN_BALANCE: true,
  CASINO_DISABLE_FUN_MODE_FOR_NOT_AUTHORIZED_USERS: true,
  CASINO_MULTIVIEW_ENABLED: 0,
  HAS_BONUS_ELIGIBLE: true,
  IS_BONUS_BALANCE_VIEW_EXPANDED_BY_DEFAULT: true,
  SHOW_DEPOSIT_CONFIRMATION_MESSAGE: true,
  IS_PAYMENT_INFO_TEXT_LONGER: true,
  IS_CASINO_FUN_MODE_UNAVAILABLE: true,
  SHOW_MULTIPLE_BET_ORIGINAL_TOTAL_ODDS: true,
  MIN_DEPOSIT_LIMIT: 5,
  SHOW_ONLY_SINGLE_AND_MULTIPLE_ODDS_IN_BET_HISTORY: true,
  OLYMPIC_ICON_OTHER: true,
  CONFLICT_MESSAGE_IN_FOOTER: true,
  CASINO_FUN_MODE: false,
  GAMBLING_LiNKS: true,
  NOTIFICATION_ACTIVE_TAB: true
} as TUkConfigs;
